module.exports = __webpack_public_path__ + "img/goldLogo.c60016bd.png";